import { render, staticRenderFns } from "./CompanyIdentificationForm.vue?vue&type=template&id=b4c61708&"
import script from "./CompanyIdentificationForm.vue?vue&type=script&lang=js&"
export * from "./CompanyIdentificationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports